import { useMemo, useRef, useState } from 'react';
import debounce from 'lodash/debounce';

import {
  FeedBrandFilterNew,
  FeedBrandFilterNewProps,
} from '@components/FeedBrandFilterNew';

import { useSearchBrandsLazyQuery } from './gql/graphql.v3.generated';

export { Option } from '@components/FeedBrandFilterNew';

type Props = Omit<FeedBrandFilterNewProps, 'inputValue' | 'onInputChange' | 'suggests'>;

type LoadBrand = (text: string) => void;

type UseBrandInput = (loadBrand: LoadBrand) => [string, (val: string) => void];
export const useBrandInput: UseBrandInput = (loadBrand) => {
  const [text, setText] = useState('');
  const loadBrandRef = useRef<LoadBrand>(undefined);
  loadBrandRef.current = loadBrand;

  const debouncedLoadBrand = useMemo(
    () => (debounce(loadBrandRef.current!, 500) as LoadBrand),
     
    [],
  );

  const setTextBrand = (newText: string) => {
    setText(newText);
    debouncedLoadBrand(newText);
  };

  return [text, setTextBrand];
};

export const FeedBrandFilterContainer: React.FC<Props> = (props) => {
  const [loadBrands, { data: searchBrands }] = useSearchBrandsLazyQuery();
  const [brandState, setBrandState] = useBrandInput(
    (text) => { loadBrands({ variables: { name: text } }); },
  );

  return (
    <FeedBrandFilterNew
      {...props}
      inputValue={brandState}
      onInputChange={setBrandState}
      suggests={searchBrands?.filterBrand || []}
    />
  );
};
